export default {
  'pages.setting.role.title': '角色管理',
  'pages.setting.role.subtitle': '管理系统角色、权限配置及功能访问控制',
  'pages.setting.role.searchPlaceholder': '搜索角色名称、编码或描述',
  // 表格列
  'pages.setting.role.column.id': '角色ID',
  'pages.setting.role.column.roleName': '角色名称',
  'pages.setting.role.column.roleKey': '角色编码',
  'pages.setting.role.column.description': '角色描述',
  'pages.setting.role.column.userCount': '用户数',
  'pages.setting.role.column.permission': '权限',
  'pages.setting.role.column.status': '状态',
  'pages.setting.role.column.createTime': '创建时间',
  'pages.setting.role.column.operation': '操作',
  // 状态
  'pages.setting.role.status.enabled': '启用',
  'pages.setting.role.status.disabled': '禁用',
  // 弹窗标题
  'pages.setting.role.modal.addTitle': '新增角色',
  'pages.setting.role.modal.editTitle': '编辑角色',
  'pages.setting.role.add': '新增角色',
  'pages.setting.role.edit': '编辑',
  // 表单
  'pages.setting.role.form.roleName': '角色名称',
  'pages.setting.role.form.roleNamePlaceholder': '请输入角色名称',
  'pages.setting.role.form.roleNameRequired': '请输入角色名称',
  'pages.setting.role.form.roleKey': '角色编码',
  'pages.setting.role.form.roleKeyPlaceholder': '例如: sales_manager',
  'pages.setting.role.form.roleKeyRequired': '请输入角色编码',
  'pages.setting.role.form.roleKeyPattern': '角色编码只能包含字母、数字、下划线，长度2-20位',
  'pages.setting.role.form.roleKeyExists': '角色编码已存在',
  'pages.setting.role.form.description': '角色描述',
  'pages.setting.role.form.descriptionPlaceholder': '请输入角色描述',
  'pages.setting.role.form.status': '状态',
  'pages.setting.role.form.statusPlaceholder': '请选择状态',
  'pages.setting.role.form.statusRequired': '请选择状态',
  'pages.setting.role.form.permission': '权限配置',
  'pages.setting.role.form.permissionRequired': '请配置权限',
  'pages.setting.role.form.selectedCount': '已选 {count} 项',
  'pages.setting.role.form.selectAll': '全选',
  'pages.setting.role.form.clear': '清空',
  // 提示消息
  'pages.setting.role.message.deleteSuccess': '删除成功',
  'pages.setting.role.message.addSuccess': '新增成功',
  'pages.setting.role.message.editSuccess': '编辑成功',
};
